import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SlateDialog from 'components/Shared/SlateDialog/SlateDialog';
import posterUrl from './media/inspect-video-poster.jpg';
import captionsUrl from './media/inspect-video.en.vtt';

// The walkthrough film in a SlateDialog. The <video> exists only while the dialog is open, so nothing downloads
// before the viewer asks. play() runs from the ref callback, inside the open's click or key press (the user
// gesture that allows sound); a refused play leaves the native controls. Every close path pauses first.
export var VIDEO_URL = 'https://documents.slatepages.com/marketing/inspect-video-v1.mp4';
export var POSTER_URL = posterUrl;
export var CAPTIONS_URL = captionsUrl;

function startPlay(el) {
  try {
    var p = el.play();
    if (p && typeof p.catch === 'function') {
      // NotAllowedError (autoplay policy) or AbortError (closed while starting): the controls stay.
      p.catch(function () {});
    }
  } catch (e) {
    // an old browser that throws: same as refused
  }
}

function stopPlay(el) {
  try {
    el.pause();
  } catch (e) {
    // nothing to stop
  }
}

export default class VideoDialog extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
    this._video = null;
    this.setVideo = this.setVideo.bind(this);
    this.close = this.close.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open && !this.props.open) {
      this.pauseVideo();
      if (this.state.failed) this.setState({ failed: false });
    }
  }

  setVideo(el) {
    if (el) {
      this._video = el;
      startPlay(el);
      return;
    }
    this.pauseVideo();
    this._video = null;
  }

  pauseVideo() {
    if (this._video) stopPlay(this._video);
  }

  close(event, reason) {
    this.pauseVideo();
    if (this.props.onClose) this.props.onClose(event, reason);
  }

  handleError() {
    this.setState({ failed: true });
  }

  render() {
    var t = this.props.t;
    return (
      <SlateDialog
        open={!!this.props.open}
        onClose={this.close}
        title={t('inspectLanding:videoDialogTitle')}
        maxWidth="md"
        className="inspect-landing-video-dialog"
        contentPadding={false}
        actions={[
          {
            key: 'close',
            label: t('inspectLanding:close'),
            variant: 'secondary',
            onClick: this.close,
          },
        ]}
      >
        <div className="inspect-landing-video-player">
          <video
            ref={this.setVideo}
            src={VIDEO_URL}
            poster={POSTER_URL}
            controls
            playsInline
            preload="auto"
            onError={this.handleError}
          >
            <track kind="captions" src={CAPTIONS_URL} srcLang="en" label={t('inspectLanding:videoCaptionsLabel')} />
          </video>
        </div>
        {this.state.failed ? (
          <p className="inspect-landing-video-error" role="alert">
            {t('inspectLanding:videoError')}
          </p>
        ) : null}
      </SlateDialog>
    );
  }
}

VideoDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};
